<template>
    <div :style="{fontSize:fSize+'px'}" :class="{'is-mobile': $root.isMobile}">
        <slot></slot>
    </div>
</template>

<script>

    let defaultWidth = 1400,
        defaultFont = 16,
        minWidth = 768,
        minHeight = 600,
        defaultHeight = 790;

    export default {
        name: 'Resize',
        mounted () {
            window.addEventListener('resize',this.onResize.bind(this))
        },
        data () {
            return {
                vW:  window.innerWidth,
                vH:  window.innerHeight
            }
        },
        computed: {
            fSize () {
                return (!this.$root.isMobile) ? 16*Math.min(Math.max(minWidth,this.vW)/defaultWidth,Math.max(minHeight,this.vH)/defaultHeight) : 16;
            }
        },
        methods: {
            onResize () {
                this.vW = window.innerWidth;
                this.vH = window.innerHeight;
            }
        }

    }
</script>




// WEBPACK FOOTER //
// Resize.vue?640fecd4